import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { toast } from '../utils';

export const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const firstPathSegment = pathname.split('/')[1];
  const user = JSON.parse(localStorage.getItem('user'));
  const appToken = localStorage.getItem('token');
  const isSuperAdmin = user ? user.superadmin : false;
  const isSuperAdminEnabled = firstPathSegment === user?.redirect;
  const isUserEnabled =
    user && user.permissions ? user.permissions.some((permission) => permission.includes(lastPathSegment)) : false;

  // Function to verify the token using jwt-decode
  const verifyToken = (token) => {
    try {
      const decoded = jwtDecode(token);
      const expiryTime = decoded.exp * 1000; // Convert expiry time to milliseconds
      return Date.now() < expiryTime; // Token is valid if the current time is before expiry
    } catch (error) {
      console.error('Token verification error:', error);
      return false;
    }
  };

  useEffect(() => {
    // Check if both tokens are present and valid
    const userTokenIsValid = user && verifyToken(user.token);
    const appTokenIsValid = appToken && verifyToken(appToken);

    if (!userTokenIsValid) {
      localStorage.clear();
      // toast(`🚫 Oops! Your Session Has Been Expire. Please contact support for help! 😕`, { variant: 'error' });
      navigate('/');
    } else if (!appTokenIsValid) {
      localStorage.clear();
      // toast(`🚫 Oops! Your Subscription Has Been Expire.Please contact support for help! 😕`, { variant: 'error' });
      navigate('/');
    }
    if (!isSuperAdminEnabled || (isSuperAdmin && !isSuperAdminEnabled) || (!isSuperAdmin && !isUserEnabled)) {
      localStorage.clear();
      // toast(`🚫 Oops! You don’t have permission to access this feature. Please contact support for help! 😕`, {
      //   variant: 'error'
      // });
      navigate('/');
    }
  }, [pathname]);

  return children;
};
